// pages/RolesPage.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Modal, Form, Input, InputNumber, Space, Card } from "antd";
import { fetchRoles, createRole, updateRole } from "@/store/adminApi/adminThunk";
import { CheckOutlined, HomeOutlined, PlusOutlined } from "@ant-design/icons";
import { Breadcrumb } from "react-bootstrap";
import { getAccessToken } from "../utils/tokenCookies";
import getUserRoles from "../utils/jwtDecode";
import { useNavigate } from "react-router-dom";

const RolesPage = () => {
  const dispatch = useDispatch();
  const { roles, loading } = useSelector((state) => state.adminApi || { roles: [], loading: false });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchRoles());
  }, [dispatch]);

  const handleAdd = () => {
    setEditingRole(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (role) => {
    setEditingRole(role);
    form.setFieldsValue({
      code: role.code,
      name: role.name,
      z_index: role.z_index,
    });
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      if (editingRole) {
        await dispatch(
          updateRole({ roleId: editingRole.id, roleData: { z_index: values.z_index } })
        );
      } else {
        // POST request 🔥
        await dispatch(createRole({
          code: values.code,
          name: values.name,
          z_index: values.z_index
        }));
      }

      setIsModalVisible(false);
      form.resetFields();
      dispatch(fetchRoles());
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };


  const columns = [
    { title: "Nomi", dataIndex: "name", key: "name" },
    { title: "Kod", dataIndex: "code", key: "code" },
    { title: "Index", dataIndex: "z_index", key: "z_index" },
    {
      title: "Harakat",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleEdit(record)}>
            Tahrirlash
          </Button>
        </Space>
      ),
    },
  ];

  // const navigate = useNavigate();

  // const token = getAccessToken();
  // const userRoles  = getUserRoles(token);

  // useEffect(() => {
  //   if (!userRoles.includes("superadmin")) {
  //     navigate("/403"); // Agar superadmin bo‘lmasa → 403 page
  //   }
  // }, [navigate, userRoles]);


  return (

    <div  >
      <Breadcrumb className="py-2">
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Tizim rollari</Breadcrumb.Item>
      </Breadcrumb>

      <Card bordered={false}>
        <Space style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleAdd}>
            <PlusOutlined /> Rol qo'shish
          </Button>
        </Space>

        <Table
          dataSource={roles || []}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 50,
            showTotal: (total) => `Jami: ${total} ta rol`,
          }}
        />

        <Modal
          title={editingRole ? "Tahrirlash" : "Qo'shish"}
          open={isModalVisible}
          onOk={handleOk}
          onCancel={() => setIsModalVisible(false)}
          okText="Saqlash"
          cancelText="Bekor qilish"
          okButtonProps={{
            icon: <CheckOutlined />
          }}
        >
          <Form form={form} layout="vertical">
            {!editingRole && (
              <>
                <Form.Item
                  name="code"
                  label="Kod"
                  rules={[{ required: true, message: "Please input code!" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="name"
                  label="Nomi"
                  rules={[{ required: true, message: "Please input name!" }]}
                >
                  <Input />
                </Form.Item>
              </>
            )}
            <Form.Item
              name="z_index"
              label="Index"
              rules={[{ required: true, message: "Please input z_index!" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Form>
        </Modal>
      </Card>
    </div>


  );
};

export default RolesPage;
